import { Button, Menu, MenuItem } from "@mui/material";
import useLogin from "./useLogin";
import JWTApi from "./JWTApi";
import { AccountCircleOutlined, LogoutOutlined } from "@mui/icons-material";
import { useState } from "react";

export default function LoginButton(props:{api:JWTApi}){
    const [anchor,setAnchor] = useState<HTMLElement|null>(null)
    const {isLoggedIn, logout, login} = useLogin()

    const onOpen = (e:React.MouseEvent<HTMLButtonElement>) => setAnchor(e.currentTarget)
    const onLogout = () => {
        setAnchor(null)
        logout()
    }
    
    return isLoggedIn ? 
        <div>
            <Button startIcon={<AccountCircleOutlined/>} onClick={onOpen}>{props.api.name}</Button>
            <Menu anchorEl={anchor} open={!!anchor} onClose={_ => setAnchor(null)}>
                <MenuItem><Button startIcon={<LogoutOutlined/>} onClick={onLogout}>Logout</Button></MenuItem>
            </Menu>
        </div>
        : <Button onClick={login}>Login</Button>
}